<template>
  <div id="main_div">
    <!-- Home Section start-->
    <section id="home">
      <div class="container">
        <div class="row">
          <h2 class="page-title">Kebijakan Privasi</h2>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="content">
            <div v-if="isLoading" class="loading-state">
              <div class="spinner"></div>
              <p>Memuat Kebijakan Privasi...</p>
            </div>
            <div v-else class="dynamic-content" v-html="privacyContent"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- Home Section End -->

    <!-- Footer Section start -->
    <NewFooterClient />
    <!-- Footer Section End -->
  </div>
</template>

<script>
import Banner from '../api/banner.js';
import Agreement from '../api/agreement.js';
import NewFooterClient from '../components/landing-page/newFooterClient.vue';

export default {
  name: 'Index',
  data() {
    return {
      privacyContent: '',
      isLoading: true
    }
  },
  components: {
    NewFooterClient
  },
  mounted() {
    this.fetchBannerData();
    this.fetchPrivacyContent();
  },
  methods: {
    fetchBannerData() {
      Banner.index().then(res => {
        // Handle response if needed
      });
    },
    fetchPrivacyContent() {
      this.isLoading = true;
      Agreement.getActivePrivacy().then(res => {
        if (res.data && res.data.data) {
          this.privacyContent = res.data.data.content;
        } else {
          this.privacyContent = '<p class="text-center">Kebijakan Privasi tidak tersedia saat ini.</p>';
        }
        this.isLoading = false;
      }).catch(err => {
        console.error('Error fetching Kebijakan Privasi:', err);
        this.privacyContent = '<p class="text-center">Gagal memuat Kebijakan Privasi. Silakan coba lagi nanti.</p>';
        this.isLoading = false;
      });
    }
  },
  beforeCreate() {
    document.body.className = '';
  }
}
</script>

<style scoped>
#home {
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #f4f7fb 0%, #e2e8f0 100%);
  min-height: 100vh;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 2.5rem;
  background: linear-gradient(90deg, #1e3c72 0%, #2a5298 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  width: 100%;
}

.content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 24px;
  padding: 3.5rem 4.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.04), 0 5px 15px rgba(0,0,0,0.02);
  margin-bottom: 4rem;
  border: 1px solid rgba(255, 255, 255, 1);
  width: 100%;
  min-height: 400px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Dynamic content styling */
.dynamic-content >>> p {
  font-family: 'Inter', 'Roboto', sans-serif;
  color: #4a5568;
  font-size: 1.05rem;
  line-height: 1.8;
  text-align: justify;
  margin-bottom: 1.2rem;
}

.dynamic-content >>> h1,
.dynamic-content >>> h2,
.dynamic-content >>> h3 {
  color: #2d3748;
  margin-top: 2.5rem;
  margin-bottom: 1.2rem;
  font-weight: 700;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.75rem;
}

.dynamic-content >>> h3 { font-size: 1.5rem; }
.dynamic-content >>> h3 strong { font-weight: 800; color: #1a365d; }
.dynamic-content >>> h4 { font-size: 1.25rem; color: #2b6cb0; margin-top: 1.8rem; font-weight: 700; }

.dynamic-content >>> ul,
.dynamic-content >>> ol {
  margin-bottom: 1.5rem;
  padding-left: 2rem;
}

.dynamic-content >>> li {
  color: #4a5568;
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 0.8rem;
  text-align: justify;
}

.dynamic-content >>> .list-alpha {
  list-style-type: lower-alpha;
}

.dynamic-content >>> .list-alpha > li {
  padding-left: 0.5rem;
}

.dynamic-content >>> .list-numeric-bracket {
  list-style-type: none;
  counter-reset: item;
  padding-left: 1.5rem;
  margin-top: 1rem;
}

.dynamic-content >>> .list-numeric-bracket > li {
  display: block;
  position: relative;
  padding-left: 2rem;
}

.dynamic-content >>> .list-numeric-bracket > li::before {
  content: counter(item) ") ";
  counter-increment: item;
  position: absolute;
  left: 0;
  font-weight: 700;
  color: #1a365d;
}

.dynamic-content >>> a {
  color: #3182ce;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.dynamic-content >>> a:hover {
  color: #2c5282;
  text-decoration: underline;
}

@media (max-width: 768px) {
  #home {
    padding: 100px 0 60px;
  }

  .content {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }

  .page-title {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/privasi.vue